import { type RiskLevel, getRiskColor } from '@/config/fraudCategories';

interface FraudRiskBadgeProps {
  level: RiskLevel;
  className?: string;
}

const LABELS: Record<RiskLevel, string> = {
  low: 'Low',
  moderate: 'Moderate',
  high: 'High',
  extreme: 'Extreme',
};

export const FraudRiskBadge = ({ level, className = '' }: FraudRiskBadgeProps) => {
  const color = getRiskColor(level);

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${className}`}
      style={{
        backgroundColor: `${color}20`,
        color,
        border: `1px solid ${color}40`,
      }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: color }}
      />
      {LABELS[level]}
    </span>
  );
};
